export const toggle = (el, showStyle = '') => {
  if (el.style.display == 'none') {
    el.style.display = showStyle
  } else {
    el.style.display = 'none'
  }
}
